import { Component, ViewChild, ElementRef, NgZone, Inject } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CatalagosConfig } from 'src/app/models/CatalogosConfig';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { httpConnect } from 'src/app/services/httpConnect.service';
import { AppOAuthStore } from 'src/app/models/AppOAuthSotarge';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
   
@Component({
  selector: 'app-root',
  templateUrl: './googlemapsearch.component.html',
  styleUrls: ['./googlemapsearch.component.scss', '../../theme/styles/_common.scss']
})

/*
Para angular 12
En caso de no mostrarse el mapa de Google o cualquier otro detalle, 
es necesario validar en el package.json que se tienen las siguientes versiones: 

bajo dependencies
"@agm/core": "3.0.0-beta.0"

bajo devDependencies:
"@types/googlemaps": "3.39.13"

o instalarlas con éstos comandos en éste orden
npm install @agm/core@3.0.0-beta.0 --save
npm install @types/googlemaps@3.39.13 --save-dev

igualmente en el módulo shared.module.ts se debe de importar
AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCZRJutcSw4BO6lp3Vuy37jnR4LNwu38Xw',
      libraries: ['places']
    })
*/

export class GoogleMapSearch {
  enableEdit: boolean = true;
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  public settings: Settings;
  private geoCoder;
  public data = {
    calle: "",
    interior: "",
    exterior: "",
    cp: "",
    colonia: "",
    id_municipio: "",
    municipio: "",
    id_estado: "",
    estado: "",
    id_pais: "",
    pais: "",
    latitud: null as number,
    longitud: null as number
  };
  @ViewChild('search')

  public searchElementRef: ElementRef;

  public catConfig: CatalagosConfig = new CatalagosConfig();
  public paisSelected : any = {};
  public estadoSelected : any = {};
  public municipioSelected : any = {};
  // public frmMunicipio = new FormControl('');
  private connectSvc;
  constructor(
    httpConn: httpConnect,    
    public appSettings : AppSettings,
    private mapsAPILoader: MapsAPILoader,
    public myStorage : AppOAuthStore,
    private ngZone: NgZone,
    private dialogGoogleMapsSearch: MatDialogRef<GoogleMapSearch>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.connectSvc = httpConn;
    this.settings = appSettings.settings;
    this.data = {...data};
    // this.geoCoder = new google.maps.Geocoder;
    this.paisSelected = { id : this.myStorage.getItem("id_pais"), value : this.myStorage.getItem("desc_pais") };
    this.estadoSelected = { id : this.myStorage.getItem("id_estado"), value : this.myStorage.getItem("desc_estado") };
    if(data.id_municipio) this.municipioSelected = { id : data['id_municipio'], value : data['municipio'] };
    this.enableEdit = typeof data.enableEdit == 'boolean' ? data.enableEdit : true;
    if (this.data.latitud == 0 && this.data.longitud == 0 && this.data.calle != undefined && this.data.calle != '') {
      this.address = [(this.data.calle || '') + ' ' + (this.data.exterior || '') + ' ' + (this.data.interior || ''), 
        (this.data.colonia || ''), (this.municipioSelected.value || ''), this.estadoSelected.value, this.paisSelected.value].join(", ");
    }
   }
  
  ngOnInit() {
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;
      this.setCurrentLocation();

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
  
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
  
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.getAddress(this.latitude, this.longitude);
          this.zoom = 15;
        });
      });
    });
  }
  
  private setCurrentLocation() {
    if (this.address != undefined) {
      this.setLocationByAddress();
    }
    else if(this.data.latitud == 0 && this.data.longitud == 0){
      this.data.latitud = Number(this.myStorage.getItem("default_lat"));
      this.data.longitud = Number(this.myStorage.getItem("default_lon"));
      this.latitude = Number(this.data.latitud);
      this.longitude = Number(this.data.longitud);
    } else {
      // navigator.geolocation.getCurrentPosition((position) => {
      //   this.latitude = position.coords.latitude || Number(this.myStorage.getItem("default_lat"));
      //   this.longitude = position.coords.longitude || Number(this.myStorage.getItem("default_lon"));
      // });
      this.latitude = Number(this.data.latitud);
      this.longitude = Number(this.data.longitud);
    }
    // this.getAddress(this.latitude, this.longitude);
    this.zoom = 17;
  }

  private setLocationByAddress() {
    let direccion: string = this.address || '';
    // let poblacion: string = this.parada.poblacion || '';
    this.geoCoder.geocode({ 'address': direccion}, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          this.latitude = results[0].geometry.location.lat();
          this.longitude = results[0].geometry.location.lng();
          this.BindResultsToAddress(results);
          this.searchPaisEstadoMunicipio();
          this.zoom = 18;
        } else {
          window.alert('No se encontrarón resultados.');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
  
    });
  }

  RefreshAddress() {
    let prevAddress = this.address;
    this.address = [(this.data.calle || '') + ' ' + (this.data.exterior || '') + ' ' + (this.data.interior || ''), 
      (this.data.colonia || ''), (this.municipioSelected.value || ''), this.estadoSelected.value, this.paisSelected.value].join(", ");
    if (prevAddress != this.address)
      this.setLocationByAddress();
  }

  MunicipioSelected(ev) {
    this.municipioSelected = ev;
    this.address = [(this.data.calle || '') + ' ' + (this.data.exterior || '') + ' ' + (this.data.interior || ''), 
      (this.data.colonia || ''), (this.municipioSelected.value || ''), this.estadoSelected.value, this.paisSelected.value].join(", ");
    this.setLocationByAddress();
  }

  markerDragEnd($event: any){
    this.latitude = Number($event.latLng.lat());
    this.longitude =  Number($event.latLng.lng());
    this.getAddress(this.latitude, this.longitude);
  }
  frm = new FormGroup({
    frmPais       : new FormControl(this.paisSelected),
    frmEstado     : new FormControl(this.estadoSelected),
    frmMunicipio  : new FormControl(this.municipioSelected),
  })

  BindResultsToAddress(results) {
    let _dir = results.find(e => e['address_components'].find(a => a.types.includes('street_number')))['address_components'];
    let exterior    = _dir.find(e=>{if(e['types'].includes('street_number')) return e; })?.long_name.trim() || '';
    let calle     = _dir.find(e=>{if(e['types'].includes('route')) return e; })?.long_name.trim() || '';
    let colonia   = _dir.find(e=>{if( 
      e['types'].includes('administrative_area_level_2') ||
      e['types'].includes('sublocality') ||
      e['types'].includes('neighborhood')
    ) return e; })?.long_name.trim() || '';
    let pais      = _dir.find(e=>{if(e['types'].includes('country')) return e; })?.long_name.trim() || '';
    let estado    = _dir.find(e=>{if(e['types'].includes('administrative_area_level_1')) return e; })?.long_name.trim() || '';
    let municipio = _dir.find(e=>{if(e['types'].includes('locality')) return e; })?.long_name.trim() || '';
    let cp        = _dir.find(e=>{if(e['types'].includes('postal_code')) return e; })?.long_name.trim() || '';
    if (exterior != '') this.data.exterior = exterior;
    if (calle != '') this.data.calle = calle;
    if (colonia != '') this.data.colonia = colonia;
    if (pais != '') this.data.pais = pais;
    if (estado != '') this.data.estado = estado;
    if (municipio != '') this.data.municipio = municipio;
    if (cp != '') this.data.cp = cp;
    this.address = results[0].formatted_address;
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.BindResultsToAddress(results);
          this.searchPaisEstadoMunicipio();
          this.zoom = 18;
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
  
    });
  }

  cerrarDialog() {
    this.dialogGoogleMapsSearch.close();
  }

  seleccionarDireccion(){
    this.data.latitud = this.latitude;
    this.data.longitud = this.longitude;
    
    this.data.id_municipio  = this.municipioSelected['id'];
    this.data.municipio     = this.municipioSelected['value'];    
    if (this.estadoSelected['id']) {
      this.data.id_estado     = this.estadoSelected['id'];
      this.data.estado        = this.estadoSelected['value'];
    }
    if (this.paisSelected['id']) {      
      this.data.id_pais       = this.paisSelected['id'];
      this.data.pais          = this.paisSelected['value'];  
    }
    this.dialogGoogleMapsSearch.close(this.data);
  }


  // 2022-02-11 (aaangeles)
  public searchPaisEstadoMunicipio() {
    // this.FiltraValores(this.catConfig.GeneralPais, this.data.pais).subscribe(d => { if (d) this.paisSelected = d[0]; }, error => { }).add(() => { });
    // this.FiltraValores(this.catConfig.GeneralEstado, this.data.estado).subscribe(d => {
    //   if (d) {
    //     this.estadoSelected = d[0];
    //     // this.FiltraValores(this.catConfig.GeneralMunicipio2, this.data.municipio).subscribe(d => {
    //     //   if (d) this.municipioSelected = d[0];
    //     // }, error => { });
    //   }
    // }, error => {}).add(() => {
      //this.settings.loadingSpinnerProcess = true
      if (this.estadoSelected['id']) 
        this.FiltraValores(this.catConfig.GeneralMunicipio2, this.data.municipio)
        .subscribe(d => { 
          if (d) this.municipioSelected = d[0]; 
        }, error => { })
       // .add(() => this.settings.loadingSpinnerProcess = false);
    // });
  }
  FiltraValores(type: any, filtro: string): Observable<any> {
    let params = {
      catalogo: type.tblName,
      value: filtro,
      padreId: type.tblName == 'general_municipio_2' && this.estadoSelected['id'] > 0 ? this.estadoSelected['id'] : -1
    }
    return this.connectSvc.postAPI("General", "ACCatalogos_ConsultaXDesc", params)
      .pipe(
        map((result: any) => {
          let res = result.response;
          return res;
        })
        , catchError(err => {
          return throwError(err.error);
        })
      )
  }
}